import type { ApiClient } from "./client";

/** `POST /support/end`: the banner's End button. Ends this support session only; the server refuses it for any other session. */
export const endSupportSession = (c: ApiClient) => c.post<{ ended: boolean }>("/support/end", {});
